import { Grid } from "@mui/material";
import FromExistingTemplate from "./FromExistingTemplate";
import FilledButton from "../../Components/Button/FilledButton";
import ISNTemplateModal from "../../Components/ISN/ISNTemplateModal";
import { useState } from "react";

const ImportTemplate = ({ showISNTemplateModal, setShowISNTemplateModal, setZeroState }) => {
    
    const [showExistingTemplateModal, setShowExistingTemplateModal] = useState(false);
    const openExistingTemplateModal = () => setShowExistingTemplateModal(true);
    const closeExistingTemplateModal = () => setShowExistingTemplateModal(false);
    
    return <>
        <ISNTemplateModal setZeroState={setZeroState} showISNTemplateModal={showISNTemplateModal} setShowISNTemplateModal={setShowISNTemplateModal} />
        <FromExistingTemplate setZeroState={setZeroState}  open={showExistingTemplateModal} handleClose={closeExistingTemplateModal}/>
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '80vh' }}
        >
            <Grid item xs={12} className="import_template_intro">
              No templates added yet. Get started by adding a new template or importing one from an existing order.
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20 }}>
                <FilledButton
                    id="Add_Template"
                    width="559px"
                    text="add new Template"
                    onClick={() => setShowISNTemplateModal(true)}
                />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 10 }}>
                <FilledButton
                    id="Import_Template"
                    width="559px"
                    text="import from previous order"
                    onClick={openExistingTemplateModal}
                />
            </Grid>
        </Grid></>
}

export default ImportTemplate;